import script from "./SenhaModal.vue?vue&type=script&setup=true&lang=js"
export * from "./SenhaModal.vue?vue&type=script&setup=true&lang=js"

import "./SenhaModal.vue?vue&type=style&index=0&id=20ec265f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20ec265f"]])

export default __exports__